<template>
  <html>
    <head> </head>
    <body>
      <navbar></navbar>
      <div class="top">
        <nav class="navbar navbar-light bg-light">
          <form class="" style="width:100vw;text-align: center;">
            <div :class="(pointType == 'Completed')? 'btPro':'btDo'" @click="show('Completed')">
              <button :class="(pointType == 'Completed')? 'btn  btn-outlines-secondary ':'btn btn-outlines-success '" type="button">
                สำเร็จ
              </button>
            </div>
            <div :class="(pointType == 'Pending')? 'btPro':'btDo'" @click="show('Pending')">
              <button :class="(pointType == 'Pending')? 'btn  btn-outlines-secondary ':'btn btn-outlines-success '" type="button"  >
                กำลังดำเนินการ
              </button>
            </div>
            <!--div class="line-c">
              <hr :class="(pointType == 'Completed')? 'new5':'new4'" />
            </div>
            <div class="line-d">
              <hr :class="(pointType == 'Pending')? 'new5':'new4'" />
            </div-->
          </form>
        </nav>
      </div>
      <!-- list completed -->
      <div v-if="pointType == 'Pending'">
      <div
      
        class="row bg-white s order-history"
       v-for="(item) in PendingOrderList"
        v-bind:key="item._id"
      >
        <a @click="goto('OrderHistoryDetail', item._id)">

          <span style="color: #7bc79a; font-weight: 600;">{{item.status | translateStatus}}</span>
          <span> {{ updatedAt(item.updatedAt) }} น.</span>
          <span> {{ item.dealname }}</span>
          <span>ยอดรวม  {{ item.amount  | numFormat('0,000,000.00')}} บาท</span>
          <span>คะแนนที่ได้รับ {{ item.point  | numFormat('0,000,000')}} คะแนน</span>
          </a>

      </div>
      </div>
      <div  v-if="pointType == 'Completed'">

      <div
     
        class="row bg-white s order-history"
       v-for="(item) in completedOrderList"
        v-bind:key="item._id"
      >
        <a @click="goto('OrderHistoryDetail', item._id)">


          <span style="color: #7bc79a; font-weight: 600;">{{item.status | translateStatus}}</span>
          <span> {{ updatedAt(item.updatedAt) }} น.</span>
          <span> {{ item.dealname }}</span>
          <span>ยอดรวม  {{ item.amount  | numFormat('0,000,000.00')}} บาท</span>
          <span>คะแนนที่ได้รับ {{ item.point  | numFormat('0,000,000')}} คะแนน</span>
          </a>

      </div>
      </div>


      <div>
                <loading
                  :active.sync="isLoading"
                  :can-cancel="false"
                  is-full-page="true"
                ></loading>
                      <div class="alert alert-success" role="alert" v-if="success">
                        บันทึกข้อมูลสำเร็จ
                      </div>
                      <div class="alert alert-danger" role="alert" v-if="failed">
                        บันทึกข้อมูลไม่สำเร็จ
                      </div>
              </div>
      
        <modal
        name="attachFile"
        width="98%"
        scrollable="true"
        height="auto"
        max-height="80%"
      >
        <attachment
        v-bind:saleInfo="item"
        @attachImage="attachImage"
        >
        </attachment>
        <div class="card-actions" style="margin-top: 16px; margin-left: 50px">
            <a
              type="submit"
              class="btn btn-reset btn-lg btn-block mt-30"
              style="background-color: #626363; color: white"
              @click="cancel('attachFile')"
              >ยกเลิก</a
            >
            <a
              type="submit"
              class="btn btn-accept light-color font-color btn-lg btn-block mt-30"
              @click="saveAttach"
              >ยืนยัน</a
            >
          </div>

      </modal>


      <div class="lastrow"></div>
      <!-- <div class="row bg-white s">
        <div>
          <img
            class="img-profile"
            src="https://media.ourgreen.co.th/wp-content/uploads/2021/06/loyalty-hub-redeem-point-img-02.jpg"
          />

          <span>แลกคะเเนนสำเร็จ</span>
          <span>18 เม.ย 2564</span>
          
          <span>2,000</span>
          <span>คะเเนน</span>
          <span>แลกรับ ลำโพงบลูทูธ JBL FLIP 5</span>
        </div>
      </div>
      -->
    </body>
  </html>
</template>
<script>
//import axios from "axios";
import { DateTimeFunc } from "../libs/constant.js";
import Navbar from "./navbar";
import Attachment from "./Attachment";
// Import component
import Loading from "vue-loading-overlay";

export default {
  name: "OrderHistory",
  components: {
    navbar: Navbar,
    attachment: Attachment,
    loading: Loading,
  },
  filters:{
    translateStatus: function(val){
      if(val == "Completed" || val == "Approved"){
        return "สำเร็จ";
      }else if(val == "Cancelled" || val == "Cancelled"){
        return "ยกเลิก";
      }else{
         return "กำลังดำเนินการ";
      }
    }
  },
  data() {
    return {
      pointType: "Completed",
      payload: {},
      info: this.$store.state.profile,
      attachImageFile:"",
      selectedItem: {},
      isLoading: false,
      success: false,
      failed: false,
    };
  },
  computed: {
    point(){
        return this.info.point || 0;
      },
    completedOrderList() {
      return this.$store.state.orderList.filter(
        (item) => item.status == "Completed"
      );
    },
    PendingOrderList() {
      return this.$store.state.orderList.filter(
        (item) => item.status == "Pending"
      );
    },
    /*
    PendingOrderList() {
      console.log(this.$store.state.Pending.history);
      return this.$store.state.Pending.history;//.filter(
      //(item) => item.status == "Approved"
      //);
    },
    PendingPendingList() {
      return this.$store.state.Pending.history;//.filter(
      //(item) => item.status == "Pending"
      //);
    },
    */
    
  },
  mounted() {
    this.completedList();
    console.log(this.$store.state.orderList);
  },
  methods: {
    updatedAt(date) {
      console.log("updatedAt");
      console.log(date);
      let ymd = date.substring(0, 10).split("-");
      //return "";
      let month = DateTimeFunc.TH_MONTH(ymd[1]);
      return ymd[2] + " " + month + " " + (parseInt(ymd[0]) + 543);
    },
    attachImage(data){
        console.log(data);
        this.attachImageFile = data;
    },
    async saveAttach(){
      this.success = false;
      this.failed = false;
      this.isLoading = true;
      //console.log(this.$store.state.cart.length);

      this.$store.dispatch("updateAttachment", {
        custId: localStorage.getItem("custId"),
        apiKey: localStorage.getItem("apiKey"),
        _id: this.selecteditem._id,
        attachImageFile: this.attachImageFile,
        
      }).then(response => {

        this.$modal.hide('attachFile');
        console.log(response)
        if(response._id !== undefined) {
          this.success = !this.success;
        } else {
          this.failed = !this.failed;
        }
      this.isLoading = false;
      });
      

     
    },

    salesDate(dateTime) {
      return DateTimeFunc.reformatDate(dateTime);
    },
    showModal(modalName,item={}) {
      console.log(item);
      this.$modal.show(modalName);
      if(item._id !== undefined ){
        this.selecteditem = item;
        console.log(this.selecteditem);
       }
    },
    cancel(name) {
      this.$modal.hide(name);
    },
     goto(page,index) {
       console.log(page);
       this.$router.push({
         name: page,
         params: {
           orderId: index,
         },
       });
     },
    show(type) {
      console.log(type);
      this.pointType = type;
    },
    completedList() {
      this.payload = {
        custId: localStorage.getItem("custId"),
        apiKey: localStorage.getItem("apiKey"),
      };
      this.$store.dispatch("orderList", {
        payload: this.payload,
        memberId: this.$store.state.profile._id,
      });
    },


  },
};
</script>
<style scoped>
@import "./Css/style.css";

.container,
.container-fluid,
.container-lg,
.container-md,
.container-sm,
.container-xl,
.container-xxl {
  width: 100%;
  padding-right: 0px;
  padding-left: 0px;
  margin-right: auto;
  margin-left: 9%;
}
.btn-outlines-success {
  font-family: "Prompt";
  /*color: #7f8285;
  border-color: #963c3c00;*/
  background-color: transparent !important;
  font-weight: bold;
  width: 100%;
  float: right;
  font-size: 19px;
    -webkit-appearance: none;
  -moz-appearance: none;
  appearance: none;
}
.btn-outlines-secondary {
  font-family: "Prompt";
  color: #003827;
  /*border-color: hsla(0, 0%, 100%, 0);*/
  font-weight: 700;
  width: 100%;
  background-color: transparent !important;
  float: left;
  font-size: 19px;
  /*margin-left: 30px;*/
    -webkit-appearance: none;
  -moz-appearance: none;
  appearance: none;
}
.navbar {
  color: #ffffff;
}
.bg-dark {
  background-color: #ffffff !important;
  height: 100px;
}
.row {
  margin-right: 9px !important;
  margin-left: 18px !important;
}
.row.bg-white.s.order-history {
    padding-top: 12px;
}
.title-page-l {
  width: 100%;
  top: 20px;
  position: absolute;
  overflow: visible;
  text-align: left;
  font-family: "Prompt";
  padding-left: 15px;
}
.title-page-l h1 {
  font-size: 30px;
  color: #ffffff;
  font-family: "Prompt";
  letter-spacing: 2px;
}
.title-page-l p {
  font-size: 14px;
  color: #ffffff;
  margin-bottom: -20px;
  text-align: left;
}
.title-page-r {
  top: 19px;
  position: absolute;
  overflow: visible;
  background: #ffffff;
  border-radius: 30px;
  width: 149px;
  left: 200px;
  height: 29px;
}
.title-page-r p {
  color: #7bc79a;
  padding-top: 10px;
  top: -14px;
}
.bg-white {
  background: #7bc79a;
  border-radius: 10px;
  height: 150px;
  width: 340px;
  position: relative;
  overflow: visible;
  top: -2px;
}
.bg-white.s {
  border-radius: 10px;
  height: 160px;
  width: 340px;
  position: relative;
  overflow: visible;
  margin-top: 15px;
  top: -6px;
}
.bg-white.ss {
  border-radius: 10px;
  height: 100%;
  width: 95%;
  position: relative;
  overflow: visible;
  margin-top: 20px;
}

h1 {
  font-size: 20px;
  margin-top: 12px;
  margin-left: 12px;
}
p {
  font-size: 16px;
  color: #7f8285;
  text-align: center;
  margin-left: 12px;
  margin-top: -12px;
}
.img-profile-redeem9 {
  display: block;
  margin-left: 9;
  margin-right: 9;
  margin-top: 21px;
  padding-right: 12px;
  width: 109px;
  height: 87px;
  float: left;
}
.name-status {
  font-family: "Prompt";
  color: #7bc79a;
  margin-top: 13px;
  font-size: 14px;
  font-weight: 700;
}
.name-now {
  font-family: "Prompt";
  color: #585858cb;
  margin-top: 13px;
  font-size: 9px;
  font-weight: bold;
  padding: 2px 2px 2px 23px;
}
.name-price {
  font-family: "Prompt";
  color: #000000;
  margin-top: 3px;
  font-size: 15px;
  padding: 7px 5px 3px 6px;
}
.name-time {
  font-family: "Prompt";
  color: #000000;
  margin-top: 32px;
  margin-bottom: 0px;
  font-size: 14px;
}
.pon {
  display: block;

  margin-right: 2px;
  margin-top: 8px;
  width: 33px;
  height: 33px;
  float: left;
}
.pon-t {
  display: block;
  margin-left: 3px;
  margin-right: 2px;
  width: 40px;
  height: 40px;
  float: left;
}
.progress {
  margin-top: 8px;
  margin-right: 2px;
  height: 0.5rem;
  border-radius: 53px;
}
.progress.s {
  margin-top: 8px;
  margin-right: 2px;
  height: 0.5rem;
  border-radius: 53px;
}
.progress-bar {
  background-color: #7bc79a;
  border-radius: 53px;
}
.progress-bar.s {
  background-color: #7bc79a;
  border-radius: 53px;
}
.lastrow {
  margin-bottom: 200px;
}
</style>
